<template>
  <div>
      <b-table
          :data="data"
          :loading="loading"
          narrowed
          striped

          paginated
          :per-page="20"

          detailed
          detail-key="id"

          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
      >

          <template slot-scope="props">
              <b-table-column field="id" label="ID" numeric sortable>
                  {{ props.row.id }}
              </b-table-column>
              <b-table-column field="type" label="Type" sortable>
                  {{ props.row.type }}
              </b-table-column>
              <b-table-column field="outputItemId" label="Output item ID" sortable>
                  {{ props.row.outputItemId }}
              </b-table-column>
              <b-table-column field="outputItemCount" label="Output item count" sortable>
                  {{ props.row.outputItemCount }}
              </b-table-column>
              <b-table-column field="craftTimeMilliseconds" label="Craft time (ms)" sortable>
                  {{ props.row.craftTimeMilliseconds }}
              </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
              <b-table :data="props.row.ingredients" :columns="detail_columns">
              </b-table>
          </template>
      </b-table>
  </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'recipes',
        data() {
            return {
                data: [],
                loading: false,
                detail_columns: [
                    {
                        field: 'itemId',
                        label: 'Item ID',
                        sortable: true,
                        numeric: true
                    },
                    {
                        field: 'count',
                        label: 'Count',
                        sortable: true
                    },
                ]
            }
        },
        methods: {
            loadAsyncData() {
                this.loading = true;
                axios.get("/database/recipes").then(response =>
                {
                    this.data = response.data;
                }).catch(error => {
                    this.data = [];
                    throw error;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>
